import { FulfillmentMapper } from 'src/data/orders/FulfillmentMapper'

import { PrivateAppAPI } from '../common/PrivateAppAPI'

import { OrderMapper, PaginatedOrderMapper } from './OrderMapper'
import {
  FulfillmentAPI,
  FulfillmentModel,
  OrderAPI,
  OrderModel,
  PaginateOrdersAPI,
  PaginateOrdersModel,
  PostCallDoctorData,
} from './type'

export class OrdersService {
  static getOrdersPaginated(
    customerId: string | number,
    page = 1,
    isChild: boolean = false
  ): Promise<PaginateOrdersModel> {
    const promise = PrivateAppAPI.request({
      url: `/orders/search`,
      method: 'GET',
      params: {
        load_relation: true,
        paginate: true,
        page,
        per_page: 10,
        partner_id: customerId,
        order_by: 'create_date',
        order_dir: 'desc',
        is_child: isChild
      },
    }).then((response: PaginateOrdersAPI) =>
      new PaginatedOrderMapper().getMappedObject({
        from: 'api',
        data: response,
      })
    ).catch((error) => {
      console.error('getOrdersPaginated error', error)
      throw error
    })
    return promise
  }

  static getOrder(orderId: string,  isChild: boolean = false): Promise<OrderModel> {
    const promise = PrivateAppAPI.request({
      url: `/orders/${orderId}`,
      method: 'GET',
      params: {
        load_relation: true,
        is_child: isChild
      },
    }).then((response: OrderAPI) =>
      new OrderMapper().getMappedObject({
        from: 'api',
        data: response,
      })
    )
    return promise
  }

  static getOrderReceipt(
    orderId: number,
    lang = 'en',
    currency = 'cad',
    isChild: boolean = false
  ): Promise<string> {
    const promise = PrivateAppAPI.request({
      url: `/orders/${orderId}/receipt`,
      method: 'GET',
      params: {
        cad: currency === 'cad',
        lang,
        hide_return: true,
        is_child: isChild
      },
    }).then((response) => `data:application/pdf;base64,${encodeURI(response)}`)
    return promise
  }

  static getOrderCustomerAuthorizationForm(customerFormId: string, isChild: boolean): Promise<string> {
    const promise = PrivateAppAPI.request({
      url: `/images/authorization-form/${customerFormId}`,
      method: 'GET',
      params: { is_child: isChild }
    }).then((response) => {
      return response.url
    })
    return promise
  }

  static getOrderFulfillments(orderId: number, isChild: boolean = false): Promise<FulfillmentModel[]> {
    const promise = PrivateAppAPI.request({
      url: `/orders/${orderId}/fulfillments`,
      method: 'GET',
      params: {
        is_child: isChild
      }
    }).then((response: FulfillmentAPI[]) =>
      response
        ? new FulfillmentMapper().getMappedObject({
            from: 'api',
            data: response,
          })
        : []
    )
    return promise
  }

  static validateOrderReceipt(
    orderId: number,
    lang = 'en',
    currency = 'cad',
    isChild = false
  ): Promise<{ is_valid: boolean; missing_order_fields: string[] }> {
    const promise = PrivateAppAPI.request(
      {
        url: `/orders/${orderId}/receipt/validate`,
        method: 'GET',
        params: {
          cad: currency === 'cad',
          lang,
          is_child: isChild
        },
      }
    )
    return promise
  }

  static getLimitedOrderIndo(orderId: string): Promise<OrderModel> {
    const promise = PrivateAppAPI.request({
      url: `/orders/balance/${orderId}`,
      method: 'GET',
      params: {
        load_relation: true,
      },
    }).then((response: OrderAPI) =>
      new OrderMapper().getMappedObject({
        from: 'api',
        data: response,
      })
    )
    return promise
  }

  static postCallDoctor(
    orderId: number,
    data: PostCallDoctorData,
    isChild: boolean,
  ): Promise<number> {
    const promise = PrivateAppAPI.request({
      url: `/orders/${orderId}/call-doctor`,
      method: 'POST',
      data,
      params: {
        is_child: isChild
      }
    }).then((response: number) => response)
    return promise
  }

  static addExistingPdToOrder(orderId: number, customerPdId: number, isChild: boolean,): Promise<OrderModel> {
    const promise = PrivateAppAPI.request({
      url: `/orders/${orderId}/pds`,
      method: 'POST',
      data: {
        customer_pd_id: customerPdId
      },
      params: {
        is_child: isChild
      }
    }).then((response: OrderAPI) => new OrderMapper().getMappedObject({
        from: 'api',
        data: response,
      }))
    return promise

  }
}
